import { render } from "./ThroughCodeEditDialog.vue?vue&type=template&id=36454ac9&scoped=true"
import script from "./ThroughCodeEditDialog.vue?vue&type=script&lang=js"
export * from "./ThroughCodeEditDialog.vue?vue&type=script&lang=js"

import "./ThroughCodeEditDialog.vue?vue&type=style&index=0&id=36454ac9&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36454ac9"]])

export default __exports__